module.exports = __webpack_public_path__ + "img/make_question.40dd4993.png";